"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorColor = exports.ActiveSpeakerIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _resources = require("../../resources");
var _ActiveSpeakerIndicator = require("./ActiveSpeakerIndicator.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var IndicatorColor = exports.IndicatorColor = {
  WHITE: 'white',
  GREEN: 'green'
};

/**
 * ActiveSpeakerIndicator component displays an indicator for the active speaker.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.color - The color to determine which GIF to display.
 * @param {boolean} props.display - The display state of the indicator.
 * @returns {JSX.Element} The rendered ActiveSpeakerIndicator component.
 */

var ActiveSpeakerIndicator = exports.ActiveSpeakerIndicator = _react["default"].memo(function (_ref) {
  var color = _ref.color,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? true : _ref$display;
  var activeSpeakerWhiteGif = _resources.resources.activeSpeakerWhiteGif,
    activeSpeakerGreenGif = _resources.resources.activeSpeakerGreenGif;
  return _react["default"].createElement(_ActiveSpeakerIndicator.ImageWrapper, {
    "data-testid": "active-speaker-indicator"
  }, _react["default"].createElement(_ActiveSpeakerIndicator.StyledImage, {
    src: color === IndicatorColor.GREEN ? activeSpeakerGreenGif : activeSpeakerWhiteGif,
    alt: "active-speaker-indicator",
    display: display
  }));
});
ActiveSpeakerIndicator.propTypes = {
  color: _propTypes["default"].oneOf([IndicatorColor.WHITE, IndicatorColor.GREEN]).isRequired,
  display: _propTypes["default"].bool
};